import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m8.829 15.944 10.944-10.57q.386-.374.92-.374.532 0 .92.374.387.375.387.889 0 .515-.387.888L9.733 18.626a1.26 1.26 0 0 1-.904.374 1.26 1.26 0 0 1-.904-.374l-5.553-5.363A1.14 1.14 0 0 1 2 12.374q.015-.514.403-.889a1.28 1.28 0 0 1 .92-.374q.533 0 .92.374l4.585 4.46Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }